import { __decorate } from "tslib";
import { AutoEncoder, StringDecoder, field, IntegerDecoder, ArrayDecoder } from '@simonbackx/simple-encoding';
export class UitpasOrganizerResponse extends AutoEncoder {
    id;
    name;
}
__decorate([
    field({ decoder: StringDecoder })
], UitpasOrganizerResponse.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], UitpasOrganizerResponse.prototype, "name", void 0);
export class UitpasOrganizersResponse extends AutoEncoder {
    totalItems;
    member;
}
__decorate([
    field({ decoder: IntegerDecoder })
], UitpasOrganizersResponse.prototype, "totalItems", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(UitpasOrganizerResponse) })
], UitpasOrganizersResponse.prototype, "member", void 0);
//# sourceMappingURL=UitpasOrganizersResponse.js.map